<template>
  <div class="faq-page">

    <div class="container py-5">
      <div class="text-center mb-4">
        <div class="faq-icon">
          <i class="fas fa-comments"></i>
        </div>

        <h1 class="page-title">
          Tanya Jawab
        </h1>

        <p class="page-subtitle">
          Temukan jawaban atas pertanyaan yang sering diajukan terkait
          konfirmasi pelanggaran, pembayaran denda, dan layanan ETLE
          Kemenhub.
        </p>
      </div>

      <div class="info-box mb-4">

        <div class="info-icon">
          <i class="fas fa-info-circle"></i>
        </div>

        <div>

          <div class="info-title">
            Informasi Penting
          </div>

          <div class="info-text">
            ETLE Kemenhub merupakan sistem penegakan hukum berbasis
            elektronik yang bertujuan mendukung pengawasan dan
            penindakan pelanggaran Over Dimension Over Loading (ODOL),
            guna meningkatkan keselamatan, ketertiban, dan kepatuhan
            penyelenggaraan angkutan darat.
          </div>

        </div>

      </div>

      <div class="accordion shadow-sm" id="mainAccordion">

        <div class="accordion-item">

          <h2 class="accordion-header" id="headingFAQ">

            <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFAQ">

              <i class="fas fa-question-circle me-2"></i>

              Pertanyaan Yang Sering Diajukan

            </button>

          </h2>

          <div id="collapseFAQ" class="accordion-collapse collapse show" data-bs-parent="#mainAccordion">

            <div class="accordion-body">

              <div class="accordion" id="faqAccordion">

                <div class="accordion-item" v-for="(faq, index) in faqs" :key="'faq' + index">

                  <h2 class="accordion-header" :id="'faqHeading' + index">

                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                      :data-bs-target="'#faqCollapse' + index">

                      {{ faq.title }}

                    </button>

                  </h2>

                  <div :id="'faqCollapse' + index" class="accordion-collapse collapse"
                    :aria-labelledby="'faqHeading' + index" data-bs-parent="#faqAccordion">

                    <div class="accordion-body">

                      {{ faq.answer }}

                    </div>

                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

        <div class="accordion-item">

          <h2 class="accordion-header" id="headingPayment">

            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
              data-bs-target="#collapsePayment">

              <i class="fas fa-wallet me-2"></i>

              Tata Cara Pembayaran BRIVA

            </button>

          </h2>

          <div id="collapsePayment" class="accordion-collapse collapse" data-bs-parent="#mainAccordion">

            <div class="accordion-body">

              <div class="accordion" id="paymentAccordion">

                <div class="accordion-item" v-for="(payment, index) in paymentSteps" :key="'payment' + index">

                  <h2 class="accordion-header" :id="'paymentHeading' + index">

                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                      :data-bs-target="'#paymentCollapse' + index">

                      <span class="badge bg-primary me-2">
                        {{ index + 1 }}
                      </span>

                      {{ payment.title }}

                    </button>

                  </h2>

                  <div :id="'paymentCollapse' + index" class="accordion-collapse collapse"
                    :aria-labelledby="'paymentHeading' + index" data-bs-parent="#paymentAccordion">

                    <div class="accordion-body">

                      <ol class="payment-list">

                        <li v-for="(step, i) in payment.steps" :key="i">
                          {{ step }}
                        </li>

                      </ol>

                    </div>

                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

    </div>

  </div>
</template>

<script>
export default {
  name: "FAQ",

  data() {
    return {
      faqs: [
        {
          title: "Saya menerima surat konfirmasi, apakah saya sudah ditilang?",
          answer:
            "Belum. Surat konfirmasi merupakan langkah awal dari proses penindakan. Pemilik kendaraan wajib melakukan konfirmasi mengenai kepemilikan kendaraan dan pengemudi pada saat pelanggaran terjadi."
        },
        {
          title: "Apa yang dimaksud dengan No Registrasi dan No TNKB?",
          answer:
            "Nomor Registrasi adalah kode unik yang tercantum pada surat konfirmasi ETLE. Nomor TNKB adalah nomor polisi kendaraan yang tertera pada plat kendaraan."
        },
        {
          title: "Berapa lama batas waktu saya untuk konfirmasi?",
          answer:
            "Konfirmasi dilakukan paling lambat 8 (delapan) hari sejak tanggal pelanggaran."
        },
        {
          title: "Apakah saya harus membayar denda menggunakan BRIVA?",
          answer:
            "Ya. Pembayaran menggunakan BRIVA merupakan metode pembayaran yang disediakan untuk mempermudah proses penyelesaian pelanggaran."
        },
        {
          title: "Kapankah batas waktu terakhir untuk pembayaran?",
          answer:
            "Pembayaran dilakukan paling lambat 15 (lima belas) hari sejak tanggal pelanggaran atau sesuai ketentuan yang tercantum pada surat konfirmasi."
        },
        {
          title: "Apakah saya dapat memilih untuk menghadiri sidang?",
          answer:
            "Ya. Anda tetap memiliki hak untuk menghadiri sidang sesuai ketentuan yang berlaku."
        },
        {
          title: "Bagaimana cara mendapatkan informasi tanggal dan lokasi sidang?",
          answer:
            "Setelah melakukan konfirmasi, informasi mengenai jadwal dan lokasi sidang akan tertera di detail pelanggaran."
        },
        {
          title: "Apa yang terjadi jika saya tidak mengetahui pengendara saat pelanggaran terjadi?",
          answer:
            "Sebagai pemilik kendaraan, Anda tetap berkewajiban memberikan informasi yang benar mengenai penggunaan kendaraan tersebut."
        },
        {
          title: "Jika kendaraan saya sudah berpindah kepemilikan, apakah saya tetap harus melakukan konfirmasi?",
          answer:
            "Ya. Anda tetap disarankan melakukan konfirmasi agar data kepemilikan kendaraan dapat segera diperbarui."
        },
        {
          title: "Apakah ada tempat konsultasi mengenai surat konfirmasi?",
          answer:
            "Anda dapat mendatangi Posko Gakkum ETLE atau kantor yang ditunjuk sesuai wilayah masing-masing."
        }
      ],

      paymentSteps: [
        {
          title: "Pembayaran Melalui BRImo",
          steps: [
            "Buka aplikasi BRImo kemudian login menggunakan User ID dan Password.",
            "Pilih menu BRIVA.",
            "Pilih Tambah Transaksi Baru.",
            "Masukkan Nomor BRIVA yang diperoleh dari sistem ETLE.",
            "Periksa nama dan nominal pembayaran.",
            "Tekan tombol Bayar.",
            "Masukkan PIN BRImo.",
            "Simpan bukti pembayaran."
          ]
        },

        {
          title: "Pembayaran Melalui ATM BRI",
          steps: [
            "Masukkan kartu ATM dan PIN.",
            "Pilih menu Transaksi Lain.",
            "Pilih menu Pembayaran.",
            "Pilih menu Lainnya.",
            "Pilih BRIVA.",
            "Masukkan Nomor BRIVA.",
            "Periksa detail pembayaran.",
            "Pilih Ya.",
            "Ambil struk pembayaran."
          ]
        },

        {
          title: "Pembayaran Melalui Agen BRILink",
          steps: [
            "Datangi Agen BRILink terdekat.",
            "Sampaikan bahwa Anda akan melakukan pembayaran BRIVA.",
            "Berikan Nomor BRIVA kepada petugas.",
            "Pastikan nama dan nominal sesuai.",
            "Lakukan pembayaran.",
            "Terima struk pembayaran sebagai bukti transaksi."
          ]
        },

        {
          title: "Transfer Melalui Mobile Banking Bank Lain",
          steps: [
            "Masuk ke aplikasi Mobile Banking.",
            "Pilih menu Transfer Antar Bank.",
            "Pilih Bank BRI (002).",
            "Masukkan Nomor BRIVA sebagai rekening tujuan.",
            "Masukkan nominal sesuai tagihan.",
            "Konfirmasi transaksi.",
            "Simpan bukti transfer."
          ]
        },

        {
          title: "Transfer Melalui ATM Bank Lain",
          steps: [
            "Masukkan kartu ATM.",
            "Masukkan PIN.",
            "Pilih Transfer Antar Bank.",
            "Masukkan kode Bank BRI (002).",
            "Masukkan Nomor BRIVA.",
            "Masukkan nominal sesuai tagihan.",
            "Konfirmasi transaksi.",
            "Ambil struk pembayaran."
          ]
        }
      ]
    };
  }
};
</script>

<style scoped>
.faq-page {
  min-height: 100vh;
  background: #f5f7fb;
}

.container {
  max-width: 980px;
}

.faq-icon {
  width: 82px;
  height: 82px;
  margin: 0 auto 18px;
  border-radius: 50%;
  background: #0d4f9c;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 34px;
  box-shadow: 0 10px 25px rgba(13, 79, 156, .25);
}

.page-title {
  color: #0d3c78;
  font-weight: 700;
  margin-bottom: 8px;
}

.page-subtitle {
  max-width: 700px;
  margin: auto;
  color: #6c757d;
  font-size: 15px;
  line-height: 1.7;
}

.info-box {

  background: linear-gradient(135deg, #0d4f9c, #1469c2);

  color: #fff;

  border-radius: 14px;

  padding: 22px;

  display: flex;

  gap: 18px;

  align-items: flex-start;

  box-shadow: 0 8px 24px rgba(13, 79, 156, .18);

}

.info-icon {

  width: 42px;

  height: 42px;

  min-width: 42px;

  border-radius: 50%;

  background: #fff;

  color: #0d4f9c;

  display: flex;

  justify-content: center;

  align-items: center;

  font-size: 20px;

}

.info-title {

  font-weight: 700;

  margin-bottom: 6px;

}

.info-text {

  font-size: 14px;

  line-height: 1.8;

}

#mainAccordion {

  border: none;

  border-radius: 12px;

  overflow: hidden;

}

#mainAccordion .accordion-item {

  border: none;

  margin-bottom: 15px;

  border-radius: 12px;

  overflow: hidden;

  box-shadow: 0 5px 18px rgba(0, 0, 0, .05);

}

#mainAccordion .accordion-button {

  background: #0d4f9c;

  color: #fff;

  font-size: 17px;

  font-weight: 600;

  padding: 18px 22px;

}

#mainAccordion .accordion-button:focus {

  box-shadow: none;

}

#mainAccordion .accordion-button:not(.collapsed) {

  background: #0a468d;

}

#mainAccordion .accordion-button::after {

  filter: brightness(0) invert(1);

}

#faqAccordion .accordion-item,
#paymentAccordion .accordion-item {

  border: 1px solid #e9ecef;

  border-radius: 10px;

  overflow: hidden;

  margin-bottom: 10px;

  box-shadow: none;

}

#faqAccordion .accordion-button,
#paymentAccordion .accordion-button {

  background: #fff;

  color: #343a40;

  font-weight: 600;

  font-size: 15px;

  padding: 15px 18px;

}

#faqAccordion .accordion-button:hover,
#paymentAccordion .accordion-button:hover {

  background: #f8fbff;

}

#faqAccordion .accordion-button:not(.collapsed),
#paymentAccordion .accordion-button:not(.collapsed) {

  background: #edf5ff;

  color: #0d4f9c;

}

#faqAccordion .accordion-button:focus,
#paymentAccordion .accordion-button:focus {

  box-shadow: none;

}

#faqAccordion .accordion-body,
#paymentAccordion .accordion-body {

  background: #fff;

  color: #495057;

  line-height: 1.8;

  font-size: 14px;

}

.payment-list {

  padding-left: 20px;

  margin-bottom: 0;

}

.payment-list li {

  margin-bottom: 10px;

}

.payment-list li:last-child {

  margin-bottom: 0;

}

.badge {

  min-width: 28px;

  height: 28px;

  display: flex;

  justify-content: center;

  align-items: center;

  border-radius: 50%;

  font-size: 12px;

}

@media(max-width:768px) {

  .faq-icon {

    width: 70px;

    height: 70px;

    font-size: 28px;

  }

  .page-title {

    font-size: 30px;

  }

  .info-box {

    flex-direction: column;

  }

  #mainAccordion .accordion-button {

    font-size: 15px;

  }

  #faqAccordion .accordion-button,
  #paymentAccordion .accordion-button {

    font-size: 14px;

  }

}
</style>
